var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9424,
    width: 2.11454,
    height: 7.40088,
    rx: 1.05727,
    fill: "#ADADAD",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.7666,
    y: 4.26233,
    width: 2.11454,
    height: 7.40088,
    rx: 1.05727,
    transform: "rotate(-45 2.7666 4.26233)",
    fill: "#ADADAD",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7373,
    y: 2.76709,
    width: 2.11454,
    height: 7.40088,
    rx: 1.05727,
    transform: "rotate(45 19.7373 2.76709)",
    fill: "#ADADAD",
    fillOpacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 10.9427,
    width: 2.11454,
    height: 7.40088,
    rx: 1.05727,
    transform: "rotate(90 24 10.9427)",
    fill: "#ADADAD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5049,
    y: 15.9996,
    width: 2.11454,
    height: 7.40088,
    rx: 1.05727,
    transform: "rotate(-45 14.5049 15.9996)",
    fill: "#ADADAD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14.5045,
    width: 2.11454,
    height: 7.40088,
    rx: 1.05727,
    transform: "rotate(45 8 14.5045)",
    fill: "#ADADAD",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.40137,
    y: 10.9427,
    width: 2.11454,
    height: 7.40088,
    rx: 1.05727,
    transform: "rotate(90 7.40137 10.9427)",
    fill: "#ADADAD",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.37782d4455a91f44d409d006aaaa23da.svg";
export { ForwardRef as ReactComponent };